<template>
  <div class="bg-sub">
    <div class=" header-page ">
      <mdb-card class="card-schedule">
        <mdb-card-header class="header-schedule">
          <h4 class="float-left">ผังรายการ</h4>
          <p class="month float-right">ผังรายการประจำเดือน {{month}} พ.ศ.{{year}}</p>
        </mdb-card-header>
        <mdb-card-body >
          <div class="">
            <mdb-tab tabs justify class="tab-channel" >
              <mdb-tab-item v-for="(item, index) in channel" :key="item.index" :active="channelActive==index" @click.native.prevent="changeChannel(item.id,index)">{{item.name}}</mdb-tab-item>
            </mdb-tab>
            <mdb-tab-content>
              <div class="">
                <mdb-tab tabs justify>
                  <mdb-tab-item class="tab-date" :active="pillsActive==0" @click.native.prevent="pillsActive=0" >MON</mdb-tab-item>
                  <mdb-tab-item class="tab-date" :active="pillsActive==1" @click.native.prevent="pillsActive=1" >TUE</mdb-tab-item>
                  <mdb-tab-item class="tab-date" :active="pillsActive==2" @click.native.prevent="pillsActive=2" >WED</mdb-tab-item>
                  <mdb-tab-item class="tab-date" :active="pillsActive==3" @click.native.prevent="pillsActive=3" >THU</mdb-tab-item>
                  <mdb-tab-item class="tab-date" :active="pillsActive==4" @click.native.prevent="pillsActive=4" >FRI</mdb-tab-item>
                  <mdb-tab-item class="tab-date" :active="pillsActive==5" @click.native.prevent="pillsActive=5" >SAT</mdb-tab-item>
                  <mdb-tab-item class="tab-date" :active="pillsActive==6" @click.native.prevent="pillsActive=6" >SUN</mdb-tab-item>
                </mdb-tab>
                <mdb-tab-content class="tab-schedule">
                    <div class="" v-if="pillsActive==0">
                      <div class="container notfound mb-5 text-center" v-if="date.monday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.monday" v-if="date.monday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="" v-if="pillsActive==1">
                      <div class="container notfound mb-5 text-center" v-if="date.tuesday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.tuesday" v-if="date.tuesday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="" v-if="pillsActive==2">
                      <div class="container notfound mb-5 text-center" v-if="date.wednesday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.wednesday" v-if="date.wednesday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="" v-if="pillsActive==3">
                      <div class="container notfound mb-5 text-center" v-if="date.thursday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.thursday" v-if="date.thursday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="" v-if="pillsActive==4">
                      <div class="container notfound mb-5 text-center" v-if="date.friday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.friday" v-if="date.friday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="" v-if="pillsActive==5">
                      <div class="container notfound mb-5 text-center" v-if="date.saturday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.saturday" v-if="date.saturday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>

                    <div class="" v-if="pillsActive==6">
                      <div class="container notfound mb-5 text-center" v-if="date.sunday == 0">
                        <img src="../../src/assets/img/finallogo.png" alt="" class="img-schedule">
                        <h3 class="text-schedule">ไม่มีรายการถ่ายทอดสดสำหรับวันนี้</h3>
                      </div>
                      <div class="box-schedule" v-for="item in date.sunday" v-if="date.sunday !== 0">
                        <div class="area-date">
                          <p>{{item.start}} : {{item.stop}} น.</p>
                        </div>
                        <div class="area-thumb">
                          <figure class="sixteen-nine-img-schedule">
                            <img :src="item.thumb">
                          </figure>
                        </div>
                        <div class="area-namechannel">
                          <p>{{item.name}}</p>
                        </div>
                      </div>
                    </div>
                </mdb-tab-content>
              </div>
            </mdb-tab-content>
          </div>

        </mdb-card-body>
      </mdb-card>
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import { mdbCarousel, mdbCarouselItem, mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbBtn, mdbInput, Btn, mdbCardHeader, mdbTab, mdbTabItem, mdbTabContent, mdbTabPane, mdbCol, mdbRow, mdbIcon, Fa } from 'mdbvue';

export default {
  name: 'SchedulePage',
  components: {
    mdbCarousel,
    mdbCarouselItem,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    Btn,
    mdbInput,
    config,
    mdbCardHeader,
    mdbTab,
    mdbTabItem,
    mdbTabContent,
    mdbCol,
    mdbRow,
    mdbIcon,
    mdbTabPane,
    Fa
  },
  data() {
    return {
      pillsActive: 0,
      channelActive: 0,
      ChangeInput: '',
      ChangeOldInput: '',
      ChangeInputCon: '',
      alertChangepass: false,
      alertwrong: false,
      channel: {},
      idChannel0: null,
      date: {},
      month: null,
      year: null
    };
  },
  mounted() {
    //this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
    this.GetChannel();
  },
  methods: {
    feedDate() {
      switch (new Date().getDay()) {
        case 0:
          this.pillsActive = 6;
          break;
        case 1:
          this.pillsActive = 0;
          break;
        case 2:
          this.pillsActive = 1;
          break;
        case 3:
          this.pillsActive = 2;
          break;
        case 4:
          this.pillsActive = 3;
          break;
        case 5:
          this.pillsActive = 4;
          break;
        case  6:
          this.pillsActive = 5;
      }
      switch (new Date().getMonth()) {
        case 0:
          this.month = 'มกราคม';
          break;
        case 1:
          this.month = 'กุมภาพันธ์';
          break;
        case 2:
          this.month = 'มีนาคม';
          break;
        case 3:
          this.month = 'เมษายน';
          break;
        case 4:
          this.month = 'พฤษภาคม';
          break;
        case 5:
          this.month = 'มิถุนายน';
          break;
        case 6:
          this.month = 'กรกฎาคม';
          break;
        case 7:
          this.month = 'สิงหาคม';
          break;
        case 8:
          this.month = 'กันยายน';
          break;
        case 9:
          this.month = 'ตุลาคม';
          break;
        case 10:
          this.month = 'พฤษจิกายน';
          break;
        case 11:
          this.month = 'ธันวาคม';
      }
    },
    GetChannel() {
      let APIgetChannel = Host + '/api/v1/schedule/channel';
      axios.get(APIgetChannel).then(response => {
        this.channel = response.data.result;
        this.idChannel0 = response.data.result[0].id;
        this.feedSchedule0();
      });
    },
    feedSchedule0() {
      let APIgetfeedSchedule0 = Host + '/api/v1/schedule/channel/detail';
      axios.post(APIgetfeedSchedule0 , {
        channel: this.idChannel0
      }).then(response => {
        this.date = response.data.schedule;
        var intyear = parseInt(response.data.year);
        this.year = intyear + 543;
        this.feedDate();
      });
    },
    changeChannel(id, index) {
      this.channelActive = index;
      let APIgetfeedSchedule = Host + '/api/v1/schedule/channel/detail';
      axios.post(APIgetfeedSchedule , {
        channel: id
      }).then(response => {
        this.date = response.data.schedule;
        var intyear = parseInt(response.data.year);
        this.year = intyear + 543;
        //this.feedDate();
      });
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    }
  }
};
</script>

<style lang="css">

.slide-toggle-enter-active {
    transition: .3s ease-in;
    opacity: 1;
    max-height: 500px;
  }

  .slide-toggle-enter,
  .slide-toggle-leave-active {
    opacity: 0;
    max-height: 0;
  }

  .slide-toggle-leave {
    opacity: 1;
    max-height: 500px;
  }


</style>
